import React from "react";
import i18n from "i18next";
import { ObjectSuperTypesEnum } from "../../enums";

export const TooltipSeatBlocker = (target: any, handleSelectObject: any, handleClose?: any) => {
    const isTouch = !!handleSelectObject;
    const isTable = target.superType === ObjectSuperTypesEnum.Table;
    const getInfoSpan = () => {
        if (target.status == "Free") {
            if (handleSelectObject)
                return (
                    <div className="box_btns_modal">
                        <button className="btn_neutro for_select" onClick={handleSelectObject}>
                            <span className="icon-checkmark"></span> Bloquear {isTable ? "mesa" : "asiento"}
                        </button>
                        {isTouch && handleClose && (
                            <button className="btn_neutro for_close" onClick={handleClose}>
                                Cerrar
                            </button>
                        )}
                    </div>
                );
            return (
                <div className="box_btns_modal">
                    <div style={{ width: '100%', marginBottom: '10px' }}>{i18n.t("tooltipSeat.click-to-not-for-sale")}</div>
                    {isTouch && handleClose && (
                        <button className="btn_neutro for_close w-100" onClick={handleClose}>
                            Cerrar
                        </button>
                    )}
                </div>
            );
        } else if (target.status == "NoForSale") {
            if (handleSelectObject)
                return (
                    <div className="box_btns_modal">
                        <button className="btn_neutro" onClick={handleSelectObject}>
                            <span className="icon-close"></span> Desbloquear {isTable ? "mesa" : "asiento"}
                        </button>
                        {isTouch && handleClose && (
                            <button className="btn_neutro for_close" onClick={handleClose}>
                                Cerrar
                            </button>
                        )}
                    </div>
                );
            return (
                <div className="box_btns_modal">
                    <div style={{ width: '100%', marginBottom: '10px' }}>{i18n.t("tooltipSeat.click-to-for-sale")}</div>
                    {isTouch && handleClose && (
                        <button className="btn_neutro for_close w-100" onClick={handleClose}>
                            Cerrar
                        </button>
                    )}
                </div>
            );
        }
        return (
            <div className="box_btns_modal">
                <div style={{ width: '100%', marginBottom: '10px' }}>{i18n.t("tooltipSeat.not-available")}</div>
                {isTouch && handleClose && (
                    <button className="btn_neutro for_close w-100" onClick={handleClose}>
                        Cerrar
                    </button>
                )}
            </div>
        );
    };

    const statusText: Record<string, string> = {
        Free: "Disponible para venta",
        NoForSale: "Disponible > No disponible para venta",
        Reserved: "No es posible cambiar el estatus",
        Booked: "No es posible cambiar el estatus",
        Pending_Payment: "No es posible cambiar el estatus"
    };

    return (
        <div
            className={`wrapper_in_tooltip_seats ${isTouch ? 'is_mobile_modal' : ''}`}
            style={{ borderLeft: `4px solid ${target.category?.color ?? ""}` }}
        >
            {statusText[target.status] && (
                <div
                    className="box_name_category"
                    style={{ color: target.category.color }}
                >
                    <p>{statusText[target.status]}</p>
                </div>
            )}
            {target.category && (
                <div
                    className="box_name_category"
                    style={{ color: target.category.color }}
                >
                    <p> {target.category.name}</p>
                </div>
            )}
            {target.restrictedView && (
                <div
                    className="box_name_icons"
                    style={{ borderColor: target.category.color }}
                >
                    <p style={{ color: target.category.color }}>
                        <span className="icon-restricted-view"></span>
                        <span>{i18n.t("tooltipSeat.restrictedView")}</span>
                    </p>
                </div>
            )}
            {target.accesible && (
                <div
                    className="box_name_icons"
                    style={{ borderColor: target.category.color }}
                >
                    <p style={{ color: target.category.color }}>
                        <span className="icon-accesible"></span>
                        <span>{i18n.t("tooltipSeat.accessible")}</span>
                    </p>
                </div>
            )}
            {target.companion && (
                <div
                    className="box_name_icons"
                    style={{ borderColor: target.category.color }}
                >
                    <p style={{ color: target.category.color }}>
                        <span className="icon-companion"></span>
                        <span>{i18n.t("tooltipSeat.companion")}</span>
                    </p>
                </div>
            )}

            <div className="box_details_seats">
                <p>
                    <span>
                        {i18n.t("tooltipSeat.section")}:{" "}
                        <strong>{target.sectionLabel || "?"}</strong>{" "}
                    </span>
                    &nbsp;
                </p>
                <p>
                    <span>
                        {i18n.t(target.rowLabel ? "tooltipSeat.row" : "tooltipSeat.table")}: <strong>{target.rowLabel || target.tableLabel || "?"}</strong>
                    </span>
                    &nbsp; &nbsp;
                    {!isTable && <span>
                        {i18n.t("tooltipSeat.seat")}:{" "}
                        <strong>{target.label || "?"}</strong>
                    </span>}
                </p>
            </div>

            <div className="box_handle_mnsj">{getInfoSpan()}</div>
        </div>
    );
};
